import {http} from "../_helpers";

class AreaService {

    getAll() {
        return http.get(`/areas`);
    }
}

export default new AreaService;
